import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=524c3d6f&scoped=true&"
import script from "./Report.vue?vue&type=script&lang=ts&"
export * from "./Report.vue?vue&type=script&lang=ts&"
import style0 from "./Report.vue?vue&type=style&index=0&id=524c3d6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524c3d6f",
  null
  
)

export default component.exports